import React, { useState, useEffect } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container
} from 'react-bootstrap'

// blogs styles
import "./styles/blogs-styles.scss"

// blog table
import BlogsTableTopBar from './includes/BlogsTable/BlogsTableTopBar'
import BlogsTable from './includes/BlogsTable/BlogsTable'

// react toastify
import { toast } from 'react-toastify';

// APIs
import { getBlogs, deleteBlog } from 'utlis/Apis/Blogs_API'

// section loading
import SectionLoading from 'utlis/helpers/SectionLoading/SectionLoading'

// pagination
import Pagination from 'components/CommonComponents/Pagination'

// common healpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'

// custom hooks
import useQuery from 'utlis/CustomHooks/useQueryHook'

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_FETCHING_BLOGS,
    ERROR_WHILE_DELETING_BLOG,
    CONFIRMATION_BEFORE_DELETING_BLOG,
    BLOG_DELETED_SUCCESSFULLY,
} from 'utlis/AppMessages/AppMessages'

function Blogs(props) {
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const [blogs, setBlogs] = useState([])
    const [loading, setLoading] = useState(true)
    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)
    const [column__Title, setColumn__Title] = useState(true)
    const [column__Status, setColumn__Status] = useState(true)
    const [column__Author, setColumn__Author] = useState(true)
    const [column__DateAdded, setColumn__DateAdded] = useState(true)

    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)
    const [paginationLinks, setPaginationLinks] = useState([])
    const [searchQuery, setSearchQuery] = useState("")
    let query = useQuery();
    let page = query.get('page')
    let keyword = query.get('keyword')

    // getting blogs
    useEffect(() => {

        // generating url parameters
        let URLParams = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`

        setSectionLoadingVisible(true)
        console.log(page, keyword)
        // getting blogs
        getBlogs(props.currentUser.userToken, URLParams).then(res => {
            // disabling section loading & loading
            setSectionLoadingVisible(false)
            setLoading(false)

            const resData = res.data

            // scroll the page to the top
            window.scrollTo(0, 0)

            // if request succesfull
            if (resData && resData.success) {
                // setting pagination links
                setPaginationLinks(resData.links)

                // settings blogs
                setBlogs(resData.data)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_FETCHING_BLOGS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getBlogs `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling section loading & loading
                    setSectionLoadingVisible(false)
                    setLoading(false)
                }
            })
        })
    }, [page, keyword, props.currentUser.userToken])

    // selecting all the columns
    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')

        // checking the checkbox and selecting all the checkboxes
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                // all checkboxes selected
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                // all checkboxes not selected
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);

    };

    // deleting
    const handleDelete = (ev, blogId) => {
        ev.preventDefault()

        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_BLOG)

        if (confirmation) {
            // enabling the section loading
            setSectionLoadingVisible(true)

            // deleting data from the api
            deleteBlog(props.currentUser.userToken, blogId).then(res => {

                // disabling the section loading
                setSectionLoadingVisible(false)

                const deletedData = res.data
                // if delete succesfully
                if (deletedData.success) {
                    // updating blogs state after deleting an blog.
                    const filtersBlogsList = blogs.filter(item => item.blog_id !== blogId)

                    // settings updated blogs
                    setBlogs(filtersBlogsList)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(BLOG_DELETED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })
                }

                // if some error while deleting
                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_BLOG, res)
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_DELETING_BLOG, {
                        autoClose: 2500,
                        onClose: () => {
                        }
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteBlogTemplate `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling the section loading
                        setSectionLoadingVisible(false)
                    }
                })
            })
        }
    }

    // searching
    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value

        // enabling section loading
        setSectionLoadingVisible(true)

        // if serch query has length
        if (searchQueryValue && searchQueryValue.length) {
            // setting search query data
            setSearchQuery(searchQueryValue)

            // redirecting to products with search data
            props.history.push(`/blogs?keyword=${searchQueryValue}&page=1`)
        }

        // if serch query does not have length
        if (!searchQueryValue) {
            // setting search query data
            setSearchQuery("")

            // redirecting to products with search data
            props.history.push(`/blogs?page=1`)
        }
    }, 500)

    return (
        <section id="app-blogs" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-blogs">
                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper d-flex mb-2">
                        {/* heading */}
                        <p className="app-heading text-capitalize">blog templates</p>
                    </div>

                    {/* CONTENT WRAPPER */}
                    <div className="app-content-container">
                        {/* app card */}
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                {/* top bar */}
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <BlogsTableTopBar
                                        column__TemplateName={column__Title}
                                        column__Author={column__Author}
                                        column__DateAdded={column__DateAdded}
                                        column__Status={column__Status}

                                        setColumn__Title={bool => setColumn__Title(bool)}
                                        setColumn__Author={bool => setColumn__Author(bool)}
                                        setColumn__Status={bool => setColumn__Status(bool)}
                                        setColumn__DateAdded={bool => setColumn__DateAdded(bool)}

                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                {/* table */}
                                <div className="st-listing-table blogs-table">
                                    <BlogsTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}

                                        column__Title={column__Title}
                                        column__Author={column__Author}
                                        column__Status={column__Status}
                                        column__DateAdded={column__DateAdded}

                                        loadingCount={loadingCount}
                                        loading={loading}

                                        blogs={blogs}

                                        handleDelete={(ev, blogId) => handleDelete(ev, blogId)}
                                    />
                                    {
                                        /* SECTION LOADING */
                                        sectionLoadingVisible && (
                                            <SectionLoading />
                                        )
                                    }
                                </div>
                            </div>

                            {/* paginations */}
                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={"/settings/blogs"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(Blogs)